@if (!footer()) {
  <a matButton
     routerLink="/subscribe"
     title="Suscríbase">
  </a>
}
@for (link of links(); track link) {
  @if (link.enabled) {
    <a matButton
       [href]="link.href"
       [title]="link.title"
       target="blanck">
    </a>
  }
}
